import React__default, { useEffect } from 'react';
import classnames from 'classnames';
import { Util } from '@grandvisionhq/common';
import { useLazyQuery, useReactiveVar } from '@grandvisionhq/graphql';
import { Icon } from '@grandvisionhq/icons';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { useCartStorage } from '../../../hooks/use-cart-storage.js';
import { getUnrecoverableValidationErrors } from '../../../utils/get-unrecoverable-validation-errors.js';
import { cartCountVar } from '../../../utils/cart-count-var.js';
import { CartCounter } from '../components/CartCounter/CartCounter.js';
import { GET_TOTAL_LINE_ITEMS } from '../../../operations/queries/get-total-line-items.js';

const CartButtonContainer = ({ href , className , label , tabIndex  })=>{
    const intl = useIntl();
    const { isClearCartOnAllErrorsEnabled  } = useFeatureToggles();
    const [cart, { setCartCount , reset  }] = useCartStorage();
    const [getTotalLineItems] = useLazyQuery(GET_TOTAL_LINE_ITEMS, {
        onCompleted: (data)=>{
            const validationErrors = data.getCart.validationErrors;
            if (validationErrors && getUnrecoverableValidationErrors(validationErrors).length) {
                // If there are unsolvable validation errors, reset the cart
                reset();
                setCartCount(0);
                return;
            }
            setCartCount(data.getCart.cart.numberOfItems);
        },
        onError: (error)=>{
            console.error(error);
            if (isClearCartOnAllErrorsEnabled) {
                reset();
            }
        }
    });
    const count = useReactiveVar(cartCountVar);
    const ariaLabel = React__default.useMemo(()=>{
        return count === 0 ? intl.getLabel('cart.emptyCart.title') : Util.getCartTotalsTitle(count, intl, 'cart.minicart.totalsTitle.singular', 'cart.minicart.totalsTitle');
    }, [
        count,
        intl
    ]);
    useEffect(()=>{
        if (cart.cartId) {
            getTotalLineItems({
                variables: {
                    id: cart.cartId
                }
            });
        }
    }, [
        cart.cartId,
        getTotalLineItems
    ]);
    return /*#__PURE__*/ React__default.createElement("a", {
        className: classnames('cart-button', className),
        href: href,
        title: label,
        tabIndex: tabIndex,
        "aria-label": tabIndex === -1 ? '' : ariaLabel
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        name: "shopping-bag"
    }), /*#__PURE__*/ React__default.createElement(CartCounter, {
        count: count
    }), label && /*#__PURE__*/ React__default.createElement("span", {
        className: "cart-button__label"
    }, label));
};

export { CartButtonContainer };
//# sourceMappingURL=CartButtonContainer.js.map
